<template>
    <div class="SurveyPageContainer">
      <div class="container">
        <div class="from">
          <div class="avatar">
            <AAvatar width="50" :src="params.from.photo" class="mr-3"/>
          </div>
          <div class="name">
            {{ params.from.name }}
          </div>
        </div>
      </div>
      <account :params="params">
            <a-tab v-for="(tab, i) in params.tabs" :key="i" :name="i">
                <form action="" method="" @submit.prevent="false">
                    <div class="account__body-section">

                        <div class="form-group row">
                            <div class="col sm-12" :class="['d'+field.greedLang, field.className]"
                                 v-for="field in fields">
                                <a-input
                                    v-if="field.type=='password'||field.type=='text'||field.type=='textarea'"
                                    :type="field.type"
                                    :data-block="field.name"
                                    :label="field.title"
                                    :placeholder="field.leftIcon?'':field.placeholder"
                                    :name="field.name"
                                    :staticLabel="field.title!=''"
                                    v-model="field.value"
                                    :error="field.error"
                                    @click="setError(field,false)"
                                    :class="field.leftIcon&&field.title?'fields-group':''"
                                >
                                    <template #before v-if="field.leftIcon">
                                        <div class="icon dark">
                                            <img :src="field.leftIcon" width="25" height="25"
                                                 style="filter: invert(1);object-fit: contain;">
                                        </div>
                                    </template>
                                </a-input>
                                <a-radio-button-group
                                    v-else-if="field.type=='radiobutton'"
                                    :data-block="field.name"
                                    :title="field.title"
                                    :options="field.options"
                                    v-model="field.value"
                                />
                                <div :data-block="field.name" v-else-if="field.type=='subtitle'"
                                     class="account__body-section">
                                    <h3>{{ field.title }}</h3>
                                </div>
                                <div :data-block="field.name" class="fields-desc" v-else-if="field.type=='label'">
                                    {{ field.value }}
                                </div>
                                <div :data-block="field.name" class="form__actions" v-else-if="field.type=='button'">
                                    <a-btn :label="field.title" class="primary d12" :fill="field.fill" type="button"
                                           @click.prevent="buttonAction(field)"/>
                                </div>
                                <pre v-else>{{ field }}</pre>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                      <div class="col d6" v-for="btn in params.btns">
                        <a-btn
                            :class="btn.className"
                            :href="btn.href"
                            @click="formSend(btn)"
                            :label="btn.title"
                            style="width: 100%"
                            :color="btn.className=='primary'?'':'var(--c-primary-200)'"
                        />
                      </div>
                    </div>
                </form>
            </a-tab>
            <template #aside>
                <account-card v-bind="params.cardInfo">
                <template #actions>

                </template>
              </account-card>
            </template>
        </account>
    </div>
</template>

<script>
import {AInput, ABtn, ATab, useAProgressBar, AAvatar} from "../components/ui";
import ARadioButtonGroup from "../components/ui/ARadioButtonGroup";
import Account from "../components/sections/Account";
import ActionCard from "../components/cards/ActionCard";
import AccountCard from '../components/cards/AccountCard.vue'
import { ref } from 'vue'
import {send} from "../services/api";
export default {
    name: "SurveyPageContainer",

    props: ['params'],

    components: {
      AAvatar,
        ActionCard,
        AccountCard,
        Account,
        ARadioButtonGroup,
        AInput, ABtn, ATab
    },

    setup(props) {
        const fields = ref(props.params.fields);
        const progress = useAProgressBar();
        const formSend = async (btn) => {
          if (btn.action !== undefined) {
            progress.show();
            let formData = new FormData();
            for (let index in fields.value) {
              if (typeof fields.value[index] == 'object') {
                formData.append(fields.value[index].name, fields.value[index].value);
              }
            }
            await send(btn.action, {method: "POST"}, formData).then((response) => {
              console.log(response[props.params.responseKey]);
              if(response[props.params.responseKey].errors) {
                let notyByType = {};
                for (let index in response[props.params.responseKey].errors)  {
                  if(response[props.params.responseKey].errors[index].type!==undefined) {
                    if(notyByType[response[props.params.responseKey].errors[index].type]===undefined) {
                      notyByType[response[props.params.responseKey].errors[index].type] = [];
                    }
                    notyByType[response[props.params.responseKey].errors[index].type].push(response[props.params.responseKey].errors[index].text);
                  }
                }
                for (let type in notyByType) {
                  showNotification(type,'',notyByType[type].join('<br>'));
                }
                progress.hide();
              } else if(response[props.params.responseKey].success) {
                showNotification(response[props.params.responseKey].success.type,'',response[props.params.responseKey].success.text);
                setTimeout(()=>{location.reload();},3000);
              }
            });
          }

        }

        const setError = (field, res) => {
            field.error = res;
        };

        const buttonAction = (field) => {
            console.log('buttonAction', field)
        }

        return {
            formSend,
            fields,
            setError
        }
    }
}
</script>

<style scoped lang="scss">
.from {
  display: flex;
  align-items: center;
}
::v-deep .account {
    margin-top: -100px;


    &__nav {
        @include tablet {
            display: none;
        }
    }

    &__body::before {
        content: unset;
    }

    @include mobile {
        margin-top: 0;
    }
}
</style>